export const hostVersion = "1.0.240";
